import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=2aaa2bd1&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aaa2bd1')) {
      api.createRecord('2aaa2bd1', component.options)
    } else {
      api.reload('2aaa2bd1', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=2aaa2bd1&", function () {
      api.rerender('2aaa2bd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/walletDetail/index.page.vue"
export default component.exports